<div class="dynamic-field form-input" [formGroup]="group">
  <label for="{{config.name}}">{{config.label | translate}}</label>
  <input type="text" id="{{config.name}}" [(ngModel)]="model" [ngbTypeahead]="search" [resultFormatter]="formatter" [inputFormatter]="formatter"
    [formControlName]="config.name" class="form-control" [ngClass]="{'error': group.controls[config.name].errors && (group.controls[config.name].touched || group.controls[config.name].dirty)}">
</div>
